import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Pages = () => {

    const { t } = useTranslation();
    const cards = [
        { name: "Home", category: "Home", value: "home" },
        { name: "Experiences", category: "Experiences", value: "experiences" },
        { name: "Weddings", category: "Weddings", value: "weddings" }
    ];

    return (
        <div className="w-full mt-10 py-1 pages">
            <div className="content-pages">
            <h1 className="admin-title">{t("Pages")}</h1>
                <div className="table-wrapper mt-5">
                    <div className="row mt-5 pt-5 justify-content-between mx-0 px-0">
                        {cards.map((card, index) => (
                            <div
                                key={index}
                                className={`col-12 col-md-4 d-flex justify-content-center mb-4`}
                            >
                                <NavLink
                                    to={`/admin/pages/update`}
                                    state={{ itemState: card.category, isEditable: true }}
                                    className={`w-100 card br-0 card-pages p-4 text-center`}
                                >
                                    
                                    <h5>{card.name}</h5>
                                    
                                </NavLink>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>

    );
};

export default Pages;
